import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';

import { http } from './http';

export const AgencyLookupsApi = {
  list: async (type: string): Promise<AxiosResponse<string[]>> => {
    return http.get(`api/${ApiVersion.V1}/agency-lookups?type=${type}`);
  },
  create: async (
    type: string,
    value: string,
  ): Promise<AxiosResponse<{ type: string; value: string }>> => {
    return http.post(`api/${ApiVersion.V1}/agency-lookups`, { type, value });
  },
};
